export default __webpack_public_path__ + "static/media/carddroping.e257777d.mp3";